
/**
 * @mixin Dialog or bar whose rendering is retargeted to the application scope.
 */
export default {
    created() {
        let parent = this.$parent;
        while (parent) {
            if (parent.hosted_ !== void 0) {
                this.host = parent;
                parent.hosted_.push(this);
                break;
            }
            parent = parent.$parent;
        }
    },

    beforeDestroy() {
        const parent = this.host;
        if (parent) {
            parent.hosted_ = parent.hosted_.filter(dialog => dialog !== this);
        }
    }
}
